/**
 * webauthn-utils.js
 * Utility to convert the Base64Url strings from your C# API into ArrayBuffers 
 * for the browser, and vice versa.
 */

export function base64urlToBuffer(baseurl) {
    const padding = '='.repeat((4 - baseurl.length % 4) % 4);
    const base64 = (baseurl + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray.buffer;
}

export function bufferToBase64url(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const charCode of bytes) {
        str += String.fromCharCode(charCode);
    }
    return window.btoa(str)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
